export default __webpack_public_path__ + "images/about/5 Татьяна Шишенина проектировщик.jpg";